import { PaletteOptions } from '@mui/material';

import { ThemeEnum } from './enums/theme.enum';
import { sofdcarPalette } from './palettes/sofdcar.palette';
import { sparqPalette } from './palettes/sparq.palette';

export const palettesDef: Map<ThemeEnum, PaletteOptions> = new Map<
  ThemeEnum,
  PaletteOptions
>([
  [ThemeEnum.SPARQ, sparqPalette],
  [ThemeEnum.SOFDCAR, sofdcarPalette],
]);
